import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';
import { LogDialogComponent } from '../log-dialog/log-dialog.component';

@Component({
  selector: 'app-log-dialog-anchor',
  templateUrl: './log-dialog-anchor.component.html',
  styleUrls: ['./log-dialog-anchor.component.css']
})
export class LogDialogAnchorComponent implements OnInit {
  @Input() logs: ILogModel[] = [];
  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  openDialogLogSolicitud(): void {
    const dialogRef = this.dialog.open(LogDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: this.logs,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

}
